<template>
  <div style="width: 100%; height: 100%; border: 10px solid #edeff2">
    <a-spin :spinning="spin">
      <div class="top">
        <!-- 第一部分 -->
        <div class="classTitle">
          <div class="topTitle title">视频分类：</div>
          <div style="display: inline-block" class="content">
            <a-radio-group
              size="small"
              default-value="0"
              button-style="solid"
              @change="onChange"
            >
              <a-radio-button value="0"> 全部 </a-radio-button>
              <a-radio-button value="-1"> 默认分类 </a-radio-button>
              <a-radio-button
                :value="item.id"
                v-for="item in topData"
                :key="item.id"
              >
                {{ item.title }}
              </a-radio-button>
            </a-radio-group>
            <!-- <admin_con
              @click="loadList"
              class="iconSheZhi"
              type="icon-shezhi"
            /> -->
          </div>
        </div>

        <!-- 第二部分 -->
        <div class="selectTop">
          <div style="display: flex">
            <span class="topTitle">素材名称：</span>
            <a-input
              v-model="imgName"
              placeholder="请输入"
              style="width: 200px; margin-left: 5px"
            />
          </div>
          <div style="display: flex">
            <span class="topTitle" style="width: 75px">上传时间：</span>
            <a-range-picker @change="timeChange" v-model="year" />
          </div>
          <div>
            <a-button
              type="primary"
              style="margin-left: 10px; font-size: 14px"
              @click="search"
              >查询</a-button
            >
            <a-button @click="clear" style="margin-left: 20px">重置</a-button>
          </div>
        </div>
      </div>
      <!-- 图 -->
      <div style="width: 100%; height: 10px; background: #edeff2"></div>
      <div class="bottom">
        <!-- 顶部 -->
        <div style="border: 1px solid #edeff2; margin-bottom: 15px">
          <div class="moTitle">
            <div class="topTitle font">视频素材列表</div>
            <div style="margin-top: 9px">
              <a class="file" href="javascript:;" v-if="!MessageShow1"
                >+上传视频
                <input
                  id="files"
                  multiple
                  ref="iconRefs"
                  type="file"
                  accept="video/*"
                  @change="upVideo($event)"
                />
              </a>
              <!-- 未认证 -->
              <a
                class="file"
                href="javascript:;"
                @click="openMessage"
                v-if="MessageShow1"
                >+上传视频</a
              >
            </div>
          </div>
        </div>

        <!-- 显示 -->
        <div style="width: 98%; margin: auto; position: relative">
          <a-row :gutter="16" type="flex" justify="start" align="bottom">
            <!-- 空数据 -->
            <div
              v-if="picture.length == 0"
              style="
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
              "
            >
              <NullDataPrompt message="暂无视频"></NullDataPrompt>
            </div>
            <a-col
              v-else
              :span="innerWidths > 0 && innerWidths < 1920 ? 5 : 4"
              style="margin-bottom: 2%"
              v-for="(item, index) in picture"
              :key="item.id"
            >
              <div
                :style="{
                  width:
                    innerWidths > 0 && innerWidths < 1920 ? '100%' : '100%',
                }"
                class="item"
                @mouseenter="showYuan(index)"
                @mouseleave="unshow"
              >
                <!-- 视频 -->
                <div style="width: 100%; height: 75%; position: relative">
                  <!-- <video
              style="width: 100%; height: 100%"
              :src="item.mediaUrl"
            ></video> -->

                  <a @click="openVideo(item)"
                    ><img
                      :src="item.coverImg"
                      style="width: 100%; height: 100%"
                  /></a>
                  <p
                    style="
                      position: absolute;
                      bottom: -12px;
                      z-index: 99999;
                      margin-left: 20px;
                    "
                  >
                    <a-icon type="play-circle" />
                    {{ item.duration }}
                  </p>
                </div>

                <div
                  class="dropdown"
                  v-show="index === selectIndex ? true : false"
                >
                  <a class="dropdown-button">
                    <a-icon
                      type="ellipsis"
                      style="font-size: 26px; color: rgb(167, 160, 160)"
                    />
                  </a>
                  <div class="dropdown-menu">
                    <a @click="changeName(index, item)"> 重命名</a>
                    <a @click="changeCategory(item)">移动分类</a>
                    <a @click="del(item)">删除</a>
                  </div>
                </div>
                <!-- 名字 -->
                <div
                  style="
                    width: 100%;
                    height: 10%;
                    font-size: 19px;
                    position: absolute;
                    bottom: 28px;
                  "
                >
                  <div
                    v-if="index == inputshow ? false : true"
                    style="
                      width: 98%;
                      margin-top: 4px;
                      margin-left: 7px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      font-size: 17px;
                      font-weight: 600;
                      color: black;
                    "
                  >
                    {{ item.title }}
                  </div>
                  <div
                    v-if="index == inputshow ? true : false"
                    style="width: 100%; height: 50%"
                  >
                    <a-input
                      v-if="index == inputshow ? true : false"
                      v-model="pictureName"
                      :placeholder="item.title"
                      @pressEnter="changeimgName(item)"
                      @blur="change"
                      id="addLabel"
                    >
                    </a-input>
                  </div>
                </div>
                <!-- 时间 -->
                <div
                  style="
                    width: 100%;
                    height: 10%;
                    position: absolute;
                    bottom: 1px;
                  "
                >
                  <p style="font-size: 16px; padding: 0px 7px; color: group">
                    {{ item.createdTime }}
                  </p>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 分页 -->
      <div style="display: flex; justify-content: center; margin-bottom: 15px">
        <a-pagination
          :current="curPage"
          :total="total"
          :pageSize="pageSize"
          show-quick-jumper
          @change="PageNOchange"
        />
      </div>

      <!-- 移动分组弹窗 -->
      <a-modal
        :visible="visible"
        title="选择分类"
        @ok="handleOk"
        @cancel="handleCancel"
        style="position: fixed; z-index: 999999"
        width="30%"
      >
        <!-- <a-button
        @click="handle(item)"
        v-for="item in topData"
        :key="item.id"
        style="margin-left: 20px"
        >{{ item.title }}</a-button
      > -->
        <a-radio-group
          button-style="solid"
          :default-value="categoryId"
          :key="categoryId"
          style="padding: 10px 10px 30px 10px"
        >
          <a-radio-button
            :value="item.id"
            v-for="item in topData"
            :key="item.id"
            @click="handle(item)"
          >
            {{ item.title }}
          </a-radio-button>
        </a-radio-group>
      </a-modal>

      <!-- 播放视频 -->
      <a-modal
        id="dialog"
        width="850px"
        hight="400"
        :visible="dialogVisible"
        :footer="null"
        @cancel="handleClose"
        style="position: fixed; z-index: 999999"
      >
        <div id="isDiv"></div>
      </a-modal>

      <!-- 删除 -->
      <a-modal
        :visible="delVisible"
        @ok="deleteOk"
        @cancel="delCancel"
        :width="300"
        :height="20"
      >
        <p style="font-size: 18px">确认删除视频？</p>
      </a-modal>
      <!-- 新增对话框 -->
      <a-modal
        title="新增分类"
        :visible="visibleClass"
        @ok="handleOkClass"
        @cancel="handleCancelClass"
        style="width: 200px; height: 130px"
      >
        <a-form-model
          :model="form"
          :rules="addRules"
          ref="ruleForm_add"
          style="display: flex"
        >
          <a-form-model-item label="分类标题" prop="name" style="display: flex">
            <a-input
              placeholder="请输入"
              v-model="form.name"
              style="display: flex; margin-top: 5px; width: 220px"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <MessageAlert
        :visible="visibleAlert"
        v-on:closeMain="closeMainAlert"
      ></MessageAlert>
    </a-spin>
  </div>
</template>

<script>
import {
  getManagement,
  getVideo,
  changeVideo,
  delVideo,
  InsertVideo,
  getSignature,
  getVideoLink,
  AddManagement,
} from "../../../service/columnmanageapi";
import { postImgList } from "@/service/document_api";
import { update, update_File } from "@/utils/update";
import MessageAlert from "@/components/Authentication/MessageAlert";
import NullDataPrompt from "../../../components/NullDataPrompt.vue";
import { admin_icon } from "@/utils/myIcon";
import { getAuthenticationInformation } from "@/service/authentication";

export default {
  name: "pictureControl",
  components: { NullDataPrompt, admin_con: admin_icon, MessageAlert },
  data() {
    return {
      form: {},
      addRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      spin: false,
      visibleClass: false,
      innerWidths: null,
      dialogVisible: false,
      topData: [],
      picture: [],
      year: [],
      typeid: "",
      imgName: "",
      pictureName: "",
      startTime: "",
      endTime: "",
      curPage: 1, //当前页
      pageSize: 8,
      total: 0, //总数
      selectIndex: -1, //圆孔显示
      boxShow: -1, //操作框显示
      inputshow: -1, //输入框显示
      visible: false, //分组弹窗显示
      category: {},
      iconList: [],
      vFile: [],
      video: [],
      shiping: {},
      videos: [],
      ship: "",
      signature: "",
      logtime: "",
      videoImg: "",
      categoryId: "",
      delete: {},
      delVisible: false,
      MessageShow1: false,
      visibleAlert: false,
      userInfoList: {},
    };
  },
  created() {
    this.getInformation();
    this.innerWidths = window.innerWidth; //屏幕宽度
    this.pageSize = this.innerWidths > 0 && this.innerWidths < 1920 ? 10 : 12;
    this.load();
  },
  methods: {
    async getInformation() {
      const response = await getAuthenticationInformation();
      if (response.code === 200) {
        this.userInfoList = response.data;
        console.log("33", this.userInfoList.memberStatus);
        if (this.userInfoList.memberStatus === 0) {
          this.MessageShow1 = true; //未认证的
        } else {
          this.MessageShow1 = false; //已认证的
        }
      } else {
        this.$message.warning("name", response.message);
      }
    },
    // 头部导航分类
    load() {
      this.spin = true;
      getManagement({
        type: "video",
        curPage: 1,
        pageSize: 9999,
      }).then((res) => {
        this.spin = false;
        this.topData = res.data;
      });
      //  获取视频
      getVideo({
        columnId: this.typeid,
        title: this.imgName,
        startTime: this.startTime,
        endTime: this.endTime,
        curPage: this.curPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.spin = false;

        this.picture = res.data;
        this.total = res.count;
        this.picture.forEach((item) => {
          let time = item.duration;
          // console.log("222", item.duration);
          let h = parseInt((time / 60 / 60) % 24);
          h = h < 10 ? "0" + h : h;
          let m = parseInt((time / 60) % 60);
          m = m < 10 ? "0" + m : m;
          let s = parseInt(time % 60);
          s = s < 10 ? "0" + s : s;
          // let time = h + ":" + m + ":" + s;
          let atime = h + ":" + m + ":" + s;
          item.duration = atime;
        });
      });
    },

    // 点击类别
    onChange(e) {
      this.curPage = 1;
      this.typeid = e.target.value;

      if (this.typeid == 0) {
        this.typeid = "";
      }
      this.load();
    },
    loadList() {
      this.visibleClass = true;
    },
    handleOkClass() {
      this.$refs.ruleForm_add.validate((valid) => {
        if (valid) {
          let data = {
            title: this.form.name,
            type: "video",
          };
          this.postClass(data);
          this.form.name = "";
          this.visibleClass = false;
        }
      });
    },
    handleCancelClass() {
      this.visibleClass = false;
    },
    async postClass(data) {
      const response = await AddManagement(data);
      if (response.code === 200) {
        this.$message.success("新增成功！");
        await this.load();
      } else {
        this.$message.warning(response.message);
      }
    },
    // 点击时间选择框
    timeChange(date, dateString) {
      this.year = dateString;
      this.startTime = dateString[0];
      this.endTime = dateString[1];
    },
    // 点击查询
    search() {
      this.curPage = 1;
      this.load();
    },
    // 点击重置
    clear() {
      this.imgName = "";
      this.startTime = "";
      this.endTime = "";
      this.year = [];
      this.load();
    },
    // 改变页码
    PageNOchange(curPage) {
      this.curPage = curPage;
      this.load();
    },
    change() {
      this.pictureName = "";
      this.inputshow = -1;
      this.load();
    },
    // 鼠标经过
    showYuan(index) {
      this.selectIndex = index;
    },
    //鼠标移开
    unshow() {
      // this.selectIndex = -1;
      this.selectIndex = -1;
    },
    changeboxShow(index) {
      this.boxShow = index;
    },
    // 重命名
    changeName(index, item) {
      this.pictureName = item.title;
      this.inputshow = index;
      this.$nextTick(function () {
        document.getElementById("addLabel").focus();
      });
    },
    // 输入框确定回调
    changeimgName(item) {
      changeVideo({
        id: item.id,
        title: this.pictureName,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.inputshow = -1;
          this.load();
          this.pictureName = "";
        }
      });
    },
    // 打开删除
    del(item) {
      this.delete = item;

      this.delVisible = true;
    },
    // 删除确定回调
    deleteOk() {
      delVideo(this.delete.id).then((res) => {
        if (res.code == 0) {
          this.$message.success("删除成功");
          this.load();
          this.delVisible = false;
        } else {
          this.$message.warning("删除失败");
        }
      });
    },
    // 删除取消回调
    delCancel() {
      this.$message.warning("取消删除");
      this.load();
      this.delVisible = false;
    },
    // 点击移动分组回调
    changeCategory(item) {
      this.visible = true;
      this.category.id = item.id;
      this.categoryId = item.columnId;
    },
    // 弹出框按钮回调
    handle(item) {
      this.category.columnId = item.id;
    },
    // 弹出框确定
    handleOk() {
      // console.log(this.category.id, this.category.columnId);
      changeVideo({
        id: this.category.id,
        columnId: this.category.columnId,
      }).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.visible = false;
          this.load();
          this.categoryId = "";
        } else {
          this.$message.warning("修改失败");
          this.visible = false;
          this.load();
          this.categoryId = "";
        }
      });
    },
    // 弹出框取消
    handleCancel() {
      this.categoryId = "";
      this.visible = false;
      this.load();
    },
    // 上传视频回调

    // 获取上传文件中的File对象信息
    // upVideo(e) {
    //   if (e.currentTarget.files) {
    //     let formData = new FormData();
    //     // 选择了文件
    //     // for (var i in e.currentTarget.files)
    //     // this.vFile.push(e.currentTarget.files[i]);
    //     // var b = this.vFile.slice(0, this.vFile.length - 2);
    //     for (const file of e.currentTarget.files) {
    //     let picture = {};
    //     picture.name = file.name;
    //     formData.append("file", file);
    //     const image = await postImgList(formData);
    //     if (image.code === 0) {
    //       for (const images of image.data.url) {
    //         picture.url = images;
    //       }
    //       this.iconList.push({
    //         url: picture.url,
    //         name: picture.name,
    //         columnId: this.typeid,
    //       });
    //     }
    //     b.forEach((item) => {
    //       this.title = item.name;
    //       this.ship = item;
    //       this.yun_getSignature();
    //       this.uploadVideoFile_toyun();
    //     });
    //   } else {
    //     // 取消选择文件
    //     this.vFile = [];
    //   }
    //   document.getElementById("up_video_surface_plot").value = null;
    // },
    // 获取上传文件中的File对象信息
    async upVideo(e) {
      this.spin = true;
      if (e.currentTarget.files) {
        for (const file of e.currentTarget.files) {
          this.ship = file;
          const res1 = await this.yun_getSignature();
          const res2 = await this.uploadVideoFile_toyun();
          // const res3 = await console.log("TEST", this.shiping);
          this.shiping.title = file.name;
        }
      }
    },
    yun_getSignature() {
      this.disabledVideo = true;
      getSignature().then((res) => {
        if (res.code === 0) {
          this.signature = res.data.signature;
          // console.log("签名", this.signature);
        }
      });
    },
    // 上传腾讯云
    async uploadVideoFile_toyun() {
      this.disabledVideo = true;
      let _this = this;
      const getSignature = () => {
        return _this.signature;
      };
      const tcVod = new _this.$TcVod({
        getSignature: getSignature, // 前面的获取上传签名的函数
      });
      const mediaFile = this.ship;
      this.vUploader = tcVod.upload({
        mediaFile: mediaFile, // 媒体文件（视频或音频或图片），类型为 File
      });
      const res1 = await this.vUploader.done().then((res) => {
        // 上传完成回调
        //视频上传后获取到的视频fileId
        this.shiping.fileId = res.fileId;
        //获取视频url地址
        this.get_video_url(res.fileId);
        this.$message.success("视频文件上传成功");
        this.spin = false;
      });
    },
    // 通过fileId获取视频url
    async get_video_url(videoId) {
      //this.disabledVideo = true;
      const response = await getVideoLink(videoId);
      if (response.code === 0) {
        this.shiping.mediaUrl = response.data.mediaUrl;
        this.getVideoBase64(response.data.mediaUrl);
        let audio = new Audio(response.data.mediaUrl);
        let self = this;
        audio.addEventListener("loadedmetadata", function (e) {
          // 时长
          self.duration = parseInt(audio.duration);
          self.logtime = self.duration;
          self.gettime();
        });
      } else {
        this.$message.warning(response.message);
      }
    },
    gettime() {
      // let h = parseInt((this.logtime / 60 / 60) % 24);
      // h = h < 10 ? "0" + h : h;
      // let m = parseInt((this.logtime / 60) % 60);
      // m = m < 10 ? "0" + m : m;
      // let s = parseInt(this.logtime % 60);
      // s = s < 10 ? "0" + s : s;
      // let time = h + ":" + m + ":" + s;
      this.shiping.duration = this.logtime;
      this.shiping.columnId = this.typeid;
      // this.shiping.type = "video";
      this.video.push(this.shiping); //push数组
      // console.log("44", this.video);
      // InsertVideo(this.video).then((res) => {
      //   this.load();
      //   this.video = [];
      //   // this.disabledVideo = false;
      // });
      //
    },

    // 获取视频第一帧图片
    getVideoBase64(url) {
      let _this = this;
      return new Promise(function (resolve, reject) {
        let dataURL = "";
        let video = document.createElement("video");
        video.setAttribute("crossOrigin", "anonymous"); //处理跨域
        video.setAttribute("src", url);
        video.setAttribute("width", 700);
        video.setAttribute("height", 600);
        video.setAttribute("preload", "auto");
        video.addEventListener("loadeddata", function () {
          let canvas = document.createElement("canvas"),
            width = video.width, //canvas的尺寸和图片一样
            height = video.height;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
          dataURL = canvas.toDataURL("image/jpeg"); //转换为base64
          _this.base64ToFile(dataURL, "封面");
        });
      });
    },
    // base64图片转file的方法（base64图片, 设置生成file的文件名）
    base64ToFile(base64, fileName) {
      // 将base64按照 , 进行分割 将前缀  与后续内容分隔开
      let data = base64.split(",");
      // 利用正则表达式 从前缀中获取图片的类型信息（image/png、image/jpeg、image/webp等）
      let type = data[0].match(/:(.*?);/)[1];
      // 从图片的类型信息中 获取具体的文件格式后缀（png、jpeg、webp）
      let suffix = type.split("/")[1];
      // 使用atob()对base64数据进行解码  结果是一个文件数据流 以字符串的格式输出
      const bstr = window.atob(data[1]);
      // 获取解码结果字符串的长度
      let n = bstr.length;
      // 根据解码结果字符串的长度创建一个等长的整形数字数组
      // 但在创建时 所有元素初始值都为 0
      const u8arr = new Uint8Array(n);
      // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
      while (n--) {
        // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
        u8arr[n] = bstr.charCodeAt(n);
      }
      // 利用构造函数创建File文件对象
      // new File(bits, name, options)
      const file = new File([u8arr], `${fileName}.${suffix}`, {
        type: type,
      });
      let inputDOM = file;
      update(inputDOM).then((res) => {
        if (res.code === 0) {
          this.shiping.coverImg = res.data.url;
          // console.log("333", this.shiping.coverImg);
          InsertVideo(this.video).then((res) => {
            this.load();
            this.video = [];
            // this.disabledVideo = false;
          });
        }
      });
    },

    // data() {
    //   return {
    //     dialogVisible: false,
    //   };
    // },
    //点击按钮出现弹窗播放视频
    openVideo(item) {
      this.sphttpurl = item.mediaUrl;
      if (!item.mediaUrl) {
        this.$message.error("暂无视频");
        return;
      }
      this.dialogVisible = true;
      // console.log(this.sphttpurl) 后台返回的视频路径
      this.$nextTick(() => {
        let str = document.createElement("video");
        window.setTimeout(function () {
          tag = document.querySelector("#isDiv").appendChild(str);
        }, 1000);
        str.id = "playVideos";
        str.src = this.sphttpurl;
        str.setAttribute("type", "video/mp4");
        str.setAttribute("controls", "controls");
        str.style.width = "800px";
        str.style.height = "400px";
        str.play();
      });
    },
    //关闭弹出框时，视频关闭播放
    handleClose() {
      const video = document.getElementById("playVideos");
      video.remove();
      this.dialogVisible = false;
    },
    closeMainAlert(val) {
      this.visibleAlert = val;
    },
    // // 是否认证
    // MessageShow() {
    //   if (this.userInfoList.memberStatus !== 0) {
    //     this.MessageShow1 = false; //已认证的
    //   } else {
    //     this.MessageShow1 = true; //未认证的
    //   }
    // },
    openMessage() {
      this.visibleAlert = true;
    },
  },
};
</script>

<style scoped lang="scss">
.ant-col-5 {
  width: 20%;
}
.ant-col-4 {
  width: 16.66666%;
}
.top {
  width: 100%;
  min-height: 130px;
  //   padding: 15px;
}
.topTitle {
  color: $topTitleColor;
}
.top {
  width: 100%;
  height: 130px;
  .classTitle {
    width: 100%;
    height: 50%;
    border-bottom: 1px solid #edeff2;
    .title {
      margin-left: 1%;
      display: inline-block;
      padding-top: 20px;
      color: $topTitleColor;
    }
    .content {
      color: $topNameColor;
      margin-left: 5px;
      .iconSheZhi {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .selectTop {
    width: 98%;
    height: 50%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    margin-top: 15px;
  }
}
.moTitle {
  display: flex;
  justify-content: space-between;
  width: 98%;
  margin: auto;
  height: 50px;
  line-height: 50px;
  .font {
    font-weight: 600;
    color: $topNameColor;
  }
}
.ant-radio-button-wrapper {
  border-radius: 5px;
  border: none;
  &::before {
    display: none; // 隐藏分界线
  }
}
::v-deep .ant-radio-button-wrapper::before {
  display: none;
}
.bottom {
  width: 100%;
  min-height: 480px;
}
.item {
  position: relative;
  //width: 23.5%;
  aspect-ratio: 1/0.85;
  // float: left;
  display: inline-block;
  border: 1.3px solid #edeff2;
  border-radius: 8px;
  margin-left: 1%;
  margin-right: 1%;
  margin-bottom: 2%;
  .yuan {
    position: absolute;
    top: 0%;
    right: 1.5%;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background: white;
    z-index: 999;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  .box {
    position: absolute;
    top: 16%;
    right: 4%;
    width: 40%;
    height: 40%;
    background: #fff;
    z-index: 999;
    border-radius: 5px;
    span {
      display: inline-block;
      background: #fff;
      width: 100%;
      height: 33.4%;
      cursor: pointer;
    }
  }
}
.file {
  position: relative;
  display: inline-block;
  background: #1890ff;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: white;
  font-size: 15px;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
}
.file input {
  position: absolute;
  font-size: 110px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: #1890ff;
  color: white;
  text-decoration: none;
}
/* 按钮样式 */
.dropdown-button {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background: white;
  text-align: center;
  line-height: 40px;
}

/* 下拉菜单 */
.dropdown-menu {
  /* 默认不显示 */
  display: none;
  /* 设置宽度 */
  width: 80px;
  /* 设置边框 */
  // border: 2px solid #e5f1fb;
  margin-top: 35px;
  border-radius: 5px;
  background-color: white;
}
/* 鼠标悬停时，显示菜单区域 */
.dropdown:hover .dropdown-menu {
  display: block;
}
/* 链接样式 */
.dropdown-menu a {
  /* 换行 */
  display: block;
  /* 黑色字体 */
  color: $topNameColor;
  /* 增大间距 */
  padding: 8px 12px;
  /* 去掉下划线 */
  text-decoration: none;
}

/* 整个下拉菜单 */
.dropdown {
  display: inline-block;
  position: absolute;
  top: 2px;
  right: 8px;
}
</style>
